<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Are you sure?</modal-header>
        </div>
        Are you sure you want to delete this link: "{{type}}" ?
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Yes, delete"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {linkMixin} from '@/mixins/linkMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {modalMixin} from '@/mixins/modalMixin'

export default {
  name: 'modal_link_confirm',
  mixins: [linkMixin, notificationMixin, modalMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    linkType: String,
    type: String
  },
  data: () => ({}),
  mounted () {},
  computed: {},
  methods: {
    confirm () {
      this.close()
      this.startLoading()
      this.deleteLink(this.confirmId).then((response) => {
        this.getLinks(this.linkType).then(() => {
          this.finishLoading()
          this.addNotification('success', response.reason)
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/links/modal-link-confirm.vue